import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import Seo from '../../components/Seo/Seo';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import services from '../../utils/services';

const Services = () => {
  return (
    <div>
      <Seo
        title="Our Services"
        description="Explore The Skilled Group's pest control, carpet cleaning, couch cleaning, mattress cleaning, and tile and grout cleaning services in Brisbane."
        canonicalPath="/services"
      />
      {/* Page Header */}
      <div className="page-header">
        <div className="container-custom">
          <h1>Our Services</h1>
          <p>
            Professional cleaning solutions for every need. Quality service,
            eco-friendly products, guaranteed satisfaction.
          </p>
        </div>
      </div>

      {/* Services Grid */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {services.map((service, index) => (
              <Link
                key={service.id}
                to={`/services/${service.slug}`}
                className="block cursor-pointer"
              >
                <ServiceCard service={service} index={index} />
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gray-50 py-16">
        <div className="container-custom text-center">
          <h2 className="text-3xl font-heading font-bold text-gray-800 mb-4">
            Not Sure Which Service You Need?
          </h2>
          <p className="text-gray-500 text-lg mb-8 max-w-2xl mx-auto">
            Contact us for a free consultation. Our team will assess your needs
            and recommend the best cleaning solution for you.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="btn-primary inline-flex items-center justify-center gap-2">
              Get Free Consultation
              <FaArrowRight className="text-sm" />
            </Link>
            <Link to="/booking" className="btn-outline inline-flex items-center justify-center gap-2">
              Book a Service
              <FaArrowRight className="text-sm" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;